module.exports = __webpack_public_path__ + "static/img/coin-trial.d9894ad3.png";